import {
  FacebookShareButton,
  TelegramShareButton,
  TwitterShareButton,
} from 'react-share';
import styles from './SharePopupContent.module.scss';
import { Icon } from '../../lib';
import { Flex } from '@/lib';

export const SharePopupContent = (props) => {
  const link = props?.link || window.location.href;

  return (
    <>
      <FacebookShareButton url={link} className={styles.shareButton}>
        <Flex align="center" gap={6} className={styles.shareItem}>
          <Icon type="facebook" color="white" />
          Facebook
        </Flex>
      </FacebookShareButton>
      <TwitterShareButton url={link} className={styles.shareButton}>
        <Flex align="center" gap={6} className={styles.shareItem}>
          <Icon type="xcom" color="white" className={styles.xcom} />X (Twitter)
        </Flex>
      </TwitterShareButton>
      <TelegramShareButton url={link} className={styles.shareButton}>
        <Flex align="center" gap={6} className={styles.shareItem}>
          <Icon type="telegram" color="white" innerColor="#000122" />
          Telegram
        </Flex>
      </TelegramShareButton>
    </>
  );
};
